import ApiClient from "./client";
import ServiceUser from "@/entities/service-user";
import ServiceUserGateway from "@/usecases/gateways/service-user-gateway";

export default class ServiceUserApi implements ServiceUserGateway {
  public constructor(private client: ApiClient) {}

  public async getAll() {
    const users: ServiceUser[] = await this.client.get("get_service_users.php");
    return users;
  }
}
